import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const ArrowUp = ({
  size,
  type,
  theme,
  className,
  dataTestId = "arrow-up-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M4.20985 7.4065C3.9495 7.66685 3.52739 7.66685 3.26704 7.4065C3.00669 7.14615 3.00669 6.72404 3.26704 6.46369L7.52899 2.20174C7.78934 1.94139 8.21145 1.94139 8.4718 2.20174L12.7337 6.46369C12.9941 6.72404 12.9941 7.14615 12.7337 7.4065C12.4734 7.66685 12.0513 7.66685 11.7909 7.4065L8.66683 4.28239V13.3283C8.66683 13.6965 8.36835 13.995 8.00016 13.995C7.63197 13.995 7.3335 13.6965 7.3335 13.3283V4.28286L4.20985 7.4065Z" />
  </SVGIcon>
);
